import React, { useEffect, useState } from 'react';
import UserForm from './components/UserForm';
import TimerPage from './components/TimerPage';
import AdminDashboard from './components/AdminDashboard';
import './App.css';

type Route =
  | { type: 'home' }
  | { type: 'admin' }
  | { type: 'timer'; tableId: string };

function parseHashRoute(hash: string): Route {
  if (hash === '#admin') {
    return { type: 'admin' };
  }

  if (hash.startsWith('#timer/')) {
    const tableId = hash.replace('#timer/', '').trim();
    if (tableId) {
      return { type: 'timer', tableId };
    }
  }

  return { type: 'home' };
}

function App() {
  const [route, setRoute] = useState<Route>(() => parseHashRoute(window.location.hash));

  useEffect(() => {
    const handleHashChange = () => {
      setRoute(parseHashRoute(window.location.hash));
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <div className="container">
      <main className="card">
        {route.type === 'admin' ? <AdminDashboard /> : null}
        {route.type === 'home' ? <UserForm /> : null}
        {route.type === 'timer' ? <TimerPage tableId={route.tableId} /> : null}
      </main>
    </div>
  );
}

export default App;
